import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Form, Input, Button, Row, Col, Space, DatePicker, Alert,
} from 'antd';

import PageContent from '../../components/Layout/PageContent';
import { currentHeroBannerGet, currentHeroBannerUpdate, heroBannerCreate } from '../../redux/actions/heroBanner';
import { loadingSelector, dataSelector, errorsSelector } from '../../redux/selectors/heroBanner';
import { validateMaxLength } from '../../helpers/form';

const HeroBannerForm = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const loading = useSelector(loadingSelector);
  const errors = useSelector(errorsSelector);
  const heroBanner = useSelector(dataSelector);

  const onPublish = (values) => {
    if (heroBanner.id) {
      dispatch(currentHeroBannerUpdate(heroBanner.id, values));
    } else {
      dispatch(heroBannerCreate(values));
    }
  };

  useEffect(() => {
    dispatch(currentHeroBannerGet());
  }, [dispatch]);

  useEffect(() => {
    form.setFieldsValue(heroBanner);
  }, [form, heroBanner]);

  return (
    <PageContent title="Hero Banner" breadcrumb={['Web', 'Hero Banner']} loading={loading}>
      {errors && <Alert message={errors} type="error" showIcon closable />}
      <Form
        form={form}
        layout="vertical"
        initialValues={heroBanner}
        validateMessages={{ required: 'This field is required', types: { url: 'Enter a valid url' } }}
        onFinish={onPublish}
        scrollToFirstError
      >
        <Form.Item
          label="Title"
          name="title"
          extra="45 characters limit"
          rules={[{
            validator: validateMaxLength,
            maxLength: 45,
          }]}
        >
          <Input size="large" placeholder="Title copy" />
        </Form.Item>
        <Form.Item
          label="Subtext"
          name="subText"
          extra="170 characters limit"
          rules={[{
            validator: validateMaxLength,
            maxLength: 170,
          }]}
        >
          <Input.TextArea placeholder="Subtext copy" />
        </Form.Item>
        <h3>Image Assets</h3>
        <Row gutter={27}>
          <Col span={12}>
            <Form.Item
              label="Desktop Background Image URL"
              name="desktopBackgroundImageURL"
              rules={[{ required: true, type: 'url' }]}
              required
            >
              <Input size="large" placeholder="https://" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Tablet Background Image URL"
              name="tabletBackgroundImageURL"
              rules={[{ required: true, type: 'url' }]}
              required
            >
              <Input size="large" placeholder="https://" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Mobile Background Image URL"
              name="mobileBackgroundImageURL"
              rules={[{ required: true, type: 'url' }]}
              required
            >
              <Input size="large" placeholder="https://" />
            </Form.Item>
          </Col>
        </Row>
        <h3>CTAs</h3>
        <Row gutter={27}>
          <Col span={12}>
            <Form.Item
              label="Button 1 Link Address"
              name="ctaLink1"
              rules={[{ type: 'url', required: true }]}
              required
            >
              <Input size="large" placeholder="https://" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Button 1 CTA Label"
              name="ctaLabel1"
              extra="25 characters limit"
              rules={[
                { required: true },
                { validator: validateMaxLength, maxLength: 25 },
              ]}
              required
            >
              <Input size="large" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Button 2 Link Address" rules={[{ type: 'url' }]} name="ctaLink2">
              <Input size="large" placeholder="https://" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Button 2 CTA Label"
              name="ctaLabel2"
              extra="25 characters limit"
              rules={[{
                validator: validateMaxLength,
                maxLength: 25,
              }]}
            >
              <Input size="large" />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item name="range-time-picker" label="Publish Date" rules={[{ type: 'array' }]}>
          <DatePicker.RangePicker size="large" showTime format="MM/DD/YYYY HH:mm:ss" />
        </Form.Item>
        <Form.Item wrapperCol={{ gutter: 16 }} style={{ marginTop: 50 }}>
          <Space>
            <Button type="primary" size="large" htmlType="submit">Publish</Button>
            <Button type="secondary" size="large">Review</Button>
            <Button type="link" size="large">Cancel</Button>
          </Space>
        </Form.Item>
      </Form>
    </PageContent>
  );
};

HeroBannerForm.propTypes = {

};

export default HeroBannerForm;
